document.addEventListener("DOMContentLoaded", function () {
  // Flickityを初期化
  var flkty = new Flickity(".Carousel", {
    prevNextButtons: false,
    pageDots: false,
    adaptiveHeight: true,
    watchCSS: true,
    dragThreshold: 8,
    initialIndex: 0,
    arrowShape: { x0: 20, x1: 60, y1: 40, x2: 60, y2: 35, x3: 25 },
  });

  // 現在の画像インデックスを表示する要素を取得
  var currentImageIndexElement = document.getElementById("currentImageIndex");

  // 現在の画像インデックスを更新する関数
  function updateCurrentImageIndex() {
    var selectedIndex = flkty.selectedIndex + 1; // インデックスを1ベースにする
    currentImageIndexElement.textContent = selectedIndex;
  }

  // Flickityのselectイベントにリスナーを追加
  flkty.on("select", updateCurrentImageIndex);

  // 初期のインデックスを設定
  updateCurrentImageIndex();

  // ポップアップを開く関数
  window.openPopup = function () {
    var popup = document.getElementById("imagePopup");
    var popupContent = document.querySelector(".PopupContent");
    document.body.style.overflow = "hidden";
    popup.style.display = "block";
    setTimeout(function () {
      popup.classList.add("open");
      popupContent.classList.add("open");
    }, 10); // openクラスを少し遅らせて追加
  };

  // ポップアップを閉じる関数
  window.closePopup = function () {
    var popup = document.getElementById("imagePopup");
    var popupContent = document.querySelector(".PopupContent");
    popupContent.classList.remove("open");
    setTimeout(function () {
      popup.classList.remove("open");
      popup.style.display = "none";
      document.body.style.overflow = "auto";
    }, 300); // アニメーションが終了するまで待ってからPopupを非表示
  };

  // 指定したmediaIdの画像を選択する関数
  window.selectImage = function (mediaId) {
    var mediaIndex = Array.from(flkty.cells).findIndex(
      (cell) => cell.element.dataset.mediaId === mediaId
    );
    if (mediaIndex !== -1) {
      flkty.select(mediaIndex); // 指定したインデックスの画像を選択
      closePopup(); // ポップアップを閉じる
    }
  };

  // ポップアップ内の画像にクリックイベントリスナーを追加
  document
    .querySelectorAll(".c-Product__SlideshowNavImage")
    .forEach(function (element) {
      element.addEventListener("click", function (event) {
        event.preventDefault(); // デフォルトのリンク動作を防ぐ
        var mediaId = this.dataset.mediaId; // クリックされた画像のmediaIdを取得
        selectImage(mediaId); // 画像を選択
      });
    });

  // ポップアップの外側をクリックしたときにポップアップを閉じる
  document
    .getElementById("imagePopup")
    .addEventListener("click", function (event) {
      if (event.target === this) {
        closePopup();
      }
    });
});
